import { useEffect, useState, useCallback } from 'react';
import { Row, Col } from 'antd';
import { useParams } from 'react-router-dom';
import UserService from '../utils/api/users';
import SupplierService from "../utils/api/supplierdirectory";
import ProfileInfo from "../components/Generals/ProfileInfo";
import LayoutPage from '../layouts/Main';

export default function Profile() {
  let { id } = useParams();
  const [profileSupplier, setProfileSupplier] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUserProfile = useCallback(async () => {
    setLoading(true);
    
    try {
      const userResponse = await UserService.GetUserById({ id });
      const userData = userResponse.data;
      setProfile(userData);
      
      const userRole = userData?.role;
      const isSupplier = userRole === 6 || userRole === '6' || userRole === 1 || userRole === '1';
      
      if (isSupplier) {
        try {
          const supplierResponse = await SupplierService.GetSupplierById(id);
          setProfileSupplier(supplierResponse.data);
        } catch (supplierError) {
          console.log("No se encontró perfil de proveedor para este usuario");
          setProfileSupplier(null);
        }
      } else {
        setProfileSupplier(null);
      }
      
    } catch (error) {
      console.error("Error fetching user profile:", error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);

  return (
    <LayoutPage>
      <Row gutter={[16, 24]}>
        <Col span={24}>
          <ProfileInfo 
            profile={profile}
            profileSupplier={profileSupplier}
            isLoading={loading} 
            onProfileUpdate={fetchUserProfile} 
          />
        </Col>
      </Row>
    </LayoutPage>
  );
}